import { render, staticRenderFns } from "./GestionAcceso.vue?vue&type=template&id=c1b8840e&scoped=true"
import script from "./GestionAcceso.vue?vue&type=script&lang=js"
export * from "./GestionAcceso.vue?vue&type=script&lang=js"
import style0 from "./GestionAcceso.vue?vue&type=style&index=0&id=c1b8840e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b8840e",
  null
  
)

export default component.exports